// DATES
export const DATE_FORMAT = 'MM/DD/YYYY'
export const DATE_FORMAT_API = 'YYYYMMDD'
export const PKG_DATE_FORMAT = 'YYYY-MM-DD'
export const PKG_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm'
export const DATE_FORMAT_DISPLAY = 'ddd, MMM D'
export const MAX_CALENDAR_DAYS = 329

// PRODUCT IDS
export const HOTEL_PRODUCT_ID = 5
export const RENTAL_CAR_PRODUCT_ID = 8
export const FLIGHT_PRODUCT_ID = 1
export const VACATION_PACKAGE_PRODUCT_ID = 17

// PRODUCTS
export const HOTEL_PRODUCT_TYPE = 'hotels'
export const FLIGHT_PRODUCT_TYPE = 'flights'
export const RENTAL_CAR_PRODUCT_TYPE = 'cars'
export const VACATION_PACKAGE_PRODUCT_TYPE = 'vacations'
export const TRIPS_PRODUCT_TYPE = 'trips'
export const CRUISE_PRODUCT_TYPE = 'cruises'

// Analytics
export const ANALYTICS_CATEGORY = 'PCLN_HOME'
export const ANALYTICS_CATEGORY_MOBILE = 'PCLN_MHOME'
export const ANALYTICS_ACTION_TAB = 'Tab'
export const ANALYTICS_CATEGORY_HOTELS = 'HOTEL_HOME'
export const ANALYTICS_CATEGORY_PACKAGE = 'Package_Home'
export const ANALYTICS_CATEGORY_FLIGHTS = 'FLIGHT_HOME'
export const ANALYTICS_ACTION_FLIGHTS_SEARCH = 'Flight Search'
export const ANALYTICS_ACTION_FLIGHTS_SEARCH_BUTTON = 'Flight Search Button'

// TRIPTYPES
export const ONE_WAY = 'one-way'
export const ROUND_TRIP = 'round-trip'
export const MULTI_DESTINATION = 'multi-destination'

// CABINS
export const ECONOMY = 'Economy'
export const PREMIUM_ECONOMY = 'Premium Economy'
export const BUSINESS_CLASS = 'Business'
export const FIRST_CLASS = 'First'

// CABINCLASSES
export const CABIN_CLASSES = [ECONOMY, PREMIUM_ECONOMY, BUSINESS_CLASS, FIRST_CLASS]

// PRODUCTTYPES
export const HOTEL_AND_CAR = 'STAY:DRIVE'
export const FLIGHT_AND_CAR = 'FLY:DRIVE'
export const HOTEL_FLIGHT_CAR = 'STAY:FLY:DRIVE'
export const HOTEL_FLIGHT = 'STAY:FLY'
export const DRIVE = 'DRIVE'
export const FLY = 'FLY'
export const STAY = 'STAY'

// Error messages
export const PARTIAL_STAY_NO_MATCH_DATE_ERROR_MESSAGE =
  'Hotel dates must fall between your flight dates'

// LENGTH OF STAYS
export const MIN_HOTEL_LENGTH_OF_STAY = 1
export const MAX_HOTEL_LENGTH_OF_STAY = 21

export const MIN_RENTAL_CAR_LENGTH_OF_STAY = 0
export const MAX_RENTAL_CAR_LENGTH_OF_STAY = 329

export const MIN_VACATION_PACKAGE_LENGTH_OF_STAY = 1
export const MAX_VACATION_PACKAGE_LENGTH_OF_STAY = 21

// Personalization

export const AIR_SEARCH_DATA = 'AIR_SEARCH_DATA'
export const CAR_SEARCH_DATA = 'CAR_SEARCH_DATA'
export const HOTEL_SEARCH_DATA = 'HOTEL_SEARCH_DATA'
export const PACKAGE_SEARCH_DATA = 'PACKAGE_SEARCH_DATA'

// SAME DAY CUT OFF (in hours)
export const HOTEL_SAME_DAY_CUT_OFF = 23
export const FLIGHT_SAME_DAY_CUT_OFF = 23
export const RENTAL_CAR_SAME_DAY_CUT_OFF = 11
export const VACTAION_PACKAGE_SAME_DAY_CUT_OFF = 16

// WHY USE PRICELINE SECTION
export const DEALS_FOR_EVERY_BUDGET = 'Deals for every budget'
export const BILLIONS_SAVED = 'Over 11 billion saved'
export const GUARANTEED_LOWEST_PRICE = 'Guaranteed lowest price'
export const HELP_24BY7 = 'Help 24/7'
export const BEST_PRICE_GUARANTEE =
  'http://www.priceline.com/landing/best-price-guarantee.htm'
export const NEED_HELP = 'https://www.priceline.com/help-page/'

export const AIR_DISCLAIMER = 'You may only book a flight for up to 8 ticketed passengers.'

// MODAL TYPES
export const HotelSearchFormModalTypes = {
  PRICEBREAKERS: 'PRICEBREAKERS',
  SOPQ: 'SOPQ',
  VIP: 'VIP'
}

export const HOME_PAGE_TAB_ORDER = {
  hotels: 0,
  vacations: 2,
  cars: 3,
  flights: 1,
  cruises: 4
}

export const HOME_PAGE_TAB_ORDER_ARRAY = [
  HOTEL_PRODUCT_TYPE,
  FLIGHT_PRODUCT_TYPE,
  VACATION_PACKAGE_PRODUCT_TYPE,
  RENTAL_CAR_PRODUCT_TYPE,
  CRUISE_PRODUCT_TYPE
]

// SEM Values
export const SEMVALUES = [
  'PLGOOGLECPC',
  'PLGOOGLECPCSL',
  'PLMSN',
  'PLMSNSL',
  'PLGEMINI',
  'PLGEMINISL',
  'PLGOOGLECPCB',
  'PLGOOGLECPCBSL',
  'PLMSNB',
  'PLMSNBSL',
  'PLGEMINIB',
  'PLGEMINIBSL'
]

export const PPN_PACKAGES_URL =
  'https://packages.priceline.com/packages/home/?refid=7709'

// RENTAL CAR TYPES
export const RENTAL_CAR_TYPES = [
  {
    code: 'ICAR',
    name: 'Mid-Size'
  },
  {
    code: 'CCAR',
    name: 'Compact'
  },
  {
    code: 'ECAR',
    name: 'Economy'
  },
  {
    code: 'SCAR',
    name: 'Standard'
  },
  {
    code: 'FCAR',
    name: 'Full-Size'
  },
  {
    code: 'PCAR',
    name: 'Premium'
  },
  {
    code: 'LCAR',
    name: 'Luxury Car'
  },
  {
    code: 'STAR',
    name: 'Convertible'
  },
  {
    code: 'IFAR',
    name: 'Mid-Size SUV'
  },
  {
    code: 'SFAR',
    name: 'Standard SUV'
  },
  {
    code: 'FFAR',
    name: 'Full-Size SUV'
  },
  {
    code: 'MVAR',
    name: 'Mini Van'
  }
]

// AIRLINES
export const AIRLINES = [
  {
    value: 'JP',
    label: 'Adria Airways'
  },
  {
    value: 'A3',
    label: 'Aegean Airlines'
  },
  {
    value: 'EI',
    label: 'Aer Lingus'
  },
  {
    value: 'SU',
    label: 'Aeroflot Russian Airlines'
  },
  {
    value: '2K',
    label: 'Aerogal - Aerolineas Galapagos'
  },
  {
    value: 'AR',
    label: 'Aerolineas Argentinas'
  },
  {
    value: 'VW',
    label: 'Aeromar Airlines'
  },
  {
    value: 'AM',
    label: 'Aeromexico'
  },
  {
    value: '5L',
    label: 'Aerosur'
  },
  {
    value: 'VV',
    label: 'Aerosvit Airlines'
  },
  {
    value: 'AB',
    label: 'Air Berlin'
  },
  {
    value: 'AC',
    label: 'Air Canada'
  },
  {
    value: 'CA',
    label: 'Air China'
  },
  {
    value: '3E',
    label: 'Air Choice One'
  },
  {
    value: 'UX',
    label: 'Air Europa'
  },
  {
    value: 'AF',
    label: 'Air France'
  },
  {
    value: 'AI',
    label: 'Air India'
  },
  {
    value: 'KM',
    label: 'Air Malta'
  },
  {
    value: '9U',
    label: 'Air Moldova'
  },
  {
    value: 'SW',
    label: 'Air Namibia'
  },
  {
    value: 'NZ',
    label: 'Air New Zealand'
  },
  {
    value: 'FJ',
    label: 'Air Pacific'
  },
  {
    value: 'VT',
    label: 'Air Tahiti'
  },
  {
    value: 'TN',
    label: 'Air Tahiti Nui'
  },
  {
    value: 'TS',
    label: 'Air Transat'
  },
  {
    value: 'BT',
    label: 'airBaltic'
  },
  {
    value: '2P',
    label: 'Airphil Express'
  },
  {
    value: 'FL',
    label: 'AirTran Airways'
  },
  {
    value: 'A9',
    label: 'Airzena Georgian Airlines'
  },
  {
    value: 'AS',
    label: 'Alaska Airlines'
  },
  {
    value: 'AZ',
    label: 'Alitalia'
  },
  {
    value: 'AA',
    label: 'American Airlines'
  },
  {
    value: 'NH',
    label: 'ANA All Nippon Airways'
  },
  {
    value: 'U8',
    label: 'Armavia'
  },
  {
    value: 'OZ',
    label: 'Asiana'
  },
  {
    value: 'KK',
    label: 'Atlasjet Airways'
  },
  {
    value: 'OS',
    label: 'Austrian Airlines'
  },
  {
    value: 'AV',
    label: 'Avianca'
  },
  {
    value: 'UP',
    label: 'Bahamasair'
  },
  {
    value: 'PG',
    label: 'Bangkok Airways'
  },
  {
    value: 'JV',
    label: 'Bearskin Airlines'
  },
  {
    value: 'B2',
    label: 'Belavia'
  },
  {
    value: 'JA',
    label: 'BH Airlines'
  },
  {
    value: 'NT',
    label: 'Binter Canarias'
  },
  {
    value: 'KF',
    label: 'Blue1'
  },
  {
    value: 'BD',
    label: 'bmi'
  },
  {
    value: 'BA',
    label: 'British Airways'
  },
  {
    value: 'SN',
    label: 'Brussels Airlines'
  },
  {
    value: 'FB',
    label: 'Bulgaria Air'
  },
  {
    value: '5T',
    label: 'Canadian North Airlines'
  },
  {
    value: '9K',
    label: 'Cape Air'
  },
  {
    value: 'BW',
    label: 'Caribbean Airlines'
  },
  {
    value: 'CX',
    label: 'Cathay Pacific'
  },
  {
    value: 'KX',
    label: 'Cayman Airways'
  },
  {
    value: '9M',
    label: 'Central Mountain Air'
  },
  {
    value: 'CI',
    label: 'China Airlines'
  },
  {
    value: 'MU',
    label: 'China Eastern Airlines'
  },
  {
    value: 'CZ',
    label: 'China Southern Airlines'
  },
  {
    value: 'QI',
    label: 'Cimber Sterling'
  },
  {
    value: 'DE',
    label: 'Condor Flugdienst'
  },
  {
    value: 'CM',
    label: 'Copa'
  },
  {
    value: 'SS',
    label: 'Corsairfly'
  },
  {
    value: 'OU',
    label: 'Croatia Airlines'
  },
  {
    value: 'CY',
    label: 'Cyprus Airways'
  },
  {
    value: 'OK',
    label: 'Czech Airlines'
  },
  {
    value: 'DL',
    label: 'Delta Air Lines'
  },
  {
    value: 'KA',
    label: 'Dragonair'
  },
  {
    value: 'MS',
    label: 'Egyptair'
  },
  {
    value: 'LY',
    label: 'El Al'
  },
  {
    value: 'EK',
    label: 'Emirates Airlines'
  },
  {
    value: '7H',
    label: 'Era Alaska'
  },
  {
    value: 'OV',
    label: 'Estonian Air'
  },
  {
    value: 'ET',
    label: 'Ethiopian'
  },
  {
    value: 'EY',
    label: 'Etihad Airways'
  },
  {
    value: 'BR',
    label: 'Eva Airways'
  },
  {
    value: 'AY',
    label: 'Finnair'
  },
  {
    value: '7F',
    label: 'First Air'
  },
  {
    value: 'BE',
    label: 'Flybe British European'
  },
  {
    value: 'FZ',
    label: 'Flydubai'
  },
  {
    value: 'F9',
    label: 'Frontier Airlines'
  },
  {
    value: 'GA',
    label: 'Garuda Airlines'
  },
  {
    value: 'YV',
    label: 'go! Mokulele'
  },
  {
    value: 'G3',
    label: 'Gol Varig'
  },
  {
    value: 'ZK',
    label: 'Great Lakes'
  },
  {
    value: 'GF',
    label: 'Gulf Air Company'
  },
  {
    value: 'HU',
    label: 'Hainan Airlines'
  },
  {
    value: 'HA',
    label: 'Hawaiian Airlines'
  },
  {
    value: 'HT',
    label: 'Hellenic Imperial Airways'
  },
  {
    value: 'UO',
    label: 'Hong Kong Express'
  },
  {
    value: 'IB',
    label: 'Iberia'
  },
  {
    value: 'FI',
    label: 'Icelandair'
  },
  {
    value: '7I',
    label: 'Insel Air'
  },
  {
    value: 'WP',
    label: 'Islandair'
  },
  {
    value: 'JL',
    label: 'Japan Airlines'
  },
  {
    value: 'NU',
    label: 'Japan Trans Ocean'
  },
  {
    value: 'JU',
    label: 'JAT Airways'
  },
  {
    value: '9W',
    label: 'Jet Airways'
  },
  {
    value: 'B6',
    label: 'JetBlue Airways'
  },
  {
    value: 'S2',
    label: 'JetLite'
  },
  {
    value: 'JQ',
    label: 'Jetstar Airways'
  },
  {
    value: 'M5',
    label: 'Kenmore Air'
  },
  {
    value: 'KQ',
    label: 'Kenya Airways'
  },
  {
    value: 'IT',
    label: 'Kingfisher Airlines'
  },
  {
    value: 'KL',
    label: 'KLM-Royal Dutch Airlines'
  },
  {
    value: 'KE',
    label: 'Korean Air'
  },
  {
    value: 'KU',
    label: 'Kuwait Airways'
  },
  {
    value: 'LR',
    label: 'Lacsa'
  },
  {
    value: 'LA',
    label: 'LAN Airlines'
  },
  {
    value: '4M',
    label: 'LAN Argentina'
  },
  {
    value: 'XL',
    label: 'LAN Ecuador'
  },
  {
    value: 'LP',
    label: 'LAN Peru'
  },
  {
    value: 'QV',
    label: 'Lao Airlines'
  },
  {
    value: 'LI',
    label: 'LIAT'
  },
  {
    value: 'LO',
    label: 'LOT Polish Airlines'
  },
  {
    value: 'LH',
    label: 'Lufthansa'
  },
  {
    value: 'LG',
    label: 'Luxair'
  },
  {
    value: 'MH',
    label: 'Malaysian'
  },
  {
    value: 'MA',
    label: 'Malev Hungarian'
  },
  {
    value: 'IG',
    label: 'Meridiana fly'
  },
  {
    value: 'OM',
    label: 'MIAT Mongolian Airlines'
  },
  {
    value: 'ME',
    label: 'Middle East Airlines'
  },
  {
    value: 'MW',
    label: 'Mokulele Airlines'
  },
  {
    value: 'OA',
    label: 'Olympic Air'
  },
  {
    value: 'WY',
    label: 'Oman Aviation'
  },
  {
    value: 'EC',
    label: 'OpenSkies'
  },
  {
    value: 'LW',
    label: 'Pacific Wings'
  },
  {
    value: 'KS',
    label: 'PenAir (Peninsula Airways)'
  },
  {
    value: 'PR',
    label: 'Philippine Airlines'
  },
  {
    value: 'PU',
    label: 'Pluna'
  },
  {
    value: 'PD',
    label: 'Porter Airlines'
  },
  {
    value: 'PW',
    label: 'Precision Air'
  },
  {
    value: 'QF',
    label: 'Qantas Airways'
  },
  {
    value: 'QR',
    label: 'Qatar Airways'
  },
  {
    value: 'FV',
    label: 'Rossiya Russian Airlines'
  },
  {
    value: 'AT',
    label: 'Royal Air Maroc'
  },
  {
    value: 'RJ',
    label: 'Royal Jordanian'
  },
  {
    value: '4Q',
    label: 'Safi Airways'
  },
  {
    value: 'S4',
    label: 'SATA International'
  },
  {
    value: 'SV',
    label: 'Saudi Arabian Airlines'
  },
  {
    value: 'SK',
    label: 'Scandinavian Airlines'
  },
  {
    value: 'K5',
    label: 'SeaPort Airlines'
  },
  {
    value: 'SC',
    label: 'Shandong Air'
  },
  {
    value: 'FM',
    label: 'Shanghai Airlines'
  },
  {
    value: '3M',
    label: 'Silver Airways'
  },
  {
    value: 'SQ',
    label: 'Singapore Airlines'
  },
  {
    value: 'H2',
    label: 'Sky Airline'
  },
  {
    value: 'SA',
    label: 'South African Airways'
  },
  {
    value: 'JK',
    label: 'Spanair'
  },
  {
    value: 'NK',
    label: 'Spirit Airlines'
  },
  {
    value: 'UL',
    label: 'Srilankan Airlines'
  },
  {
    value: 'SY',
    label: 'Sun Country Airlines'
  },
  {
    value: 'PY',
    label: 'Surinam Air'
  },
  {
    value: 'LX',
    label: 'SWISS'
  },
  {
    value: 'TA',
    label: 'TACA International'
  },
  {
    value: 'JJ',
    label: 'TAM Brazilian Airlines'
  },
  {
    value: 'TP',
    label: 'TAP Air Portugal'
  },
  {
    value: 'RO',
    label: 'Tarom'
  },
  {
    value: 'TG',
    label: 'Thai Airways Intl'
  },
  {
    value: 'UN',
    label: 'Transaero'
  },
  {
    value: 'PZ',
    label: 'Transportes Aereos Del Mercosur'
  },
  {
    value: 'TK',
    label: 'Turkish Airlines'
  },
  {
    value: 'PS',
    label: 'Ukraine International Airlines'
  },
  {
    value: 'B7',
    label: 'UNI Airways'
  },
  {
    value: 'UA',
    label: 'United Airlines'
  },
  {
    value: 'US',
    label: 'US Airways'
  },
  {
    value: 'VN',
    label: 'Vietnam Airlines'
  },
  {
    value: 'VX',
    label: 'Virgin America'
  },
  {
    value: 'VS',
    label: 'Virgin Atlantic'
  },
  {
    value: 'VA',
    label: 'Virgin Australia International'
  },
  {
    value: 'V2',
    label: 'Vision Airlines'
  },
  {
    value: 'WS',
    label: 'WestJet'
  },
  {
    value: 'WF',
    label: 'Wideroes Flyveselskap'
  },
  {
    value: 'WM',
    label: 'Windward Island Airways Intl'
  },
  {
    value: 'MF',
    label: 'Xiamen Airlines'
  },
  {
    value: 'SE',
    label: 'XL Airways France'
  }
]

export const CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]'

export const CURRENT_LOCATION_INITIAL_OPTIONS = {
  currentLocation: {
    itemName: 'Use Current Location',
    content: 'Use Current Location',
    type: 'GEO',
    isCurrentLocation: true
  },
  showCurrentLocation: true,
  isCurrentLocationDisabled: false
}
